export default function PrivacyPolicy() {
  return null;
}
